import axios from 'axios';
import { API_BASE_URL } from './config';

// 使用相对路径：生产环境 baseURL 为空，请求如 /api/captcha/ 即发往当前域名；开发环境可为空或指定后端地址
axios.defaults.baseURL = API_BASE_URL ?? '';
axios.defaults.withCredentials = true;  // 允许跨域携带 cookie
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

const NO_AUTH_ENDPOINTS = ['/api/captcha/', '/api/login/', '/api/test-login/'];

const needsAuth = (url = '') => !NO_AUTH_ENDPOINTS.some((endpoint) => url.includes(endpoint));

const setAuthHeader = (config, token) => {
  if (!token) return;
  if (config.headers?.set) {
    config.headers.set('Authorization', `Bearer ${token}`);
  } else {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
};

// 请求拦截器：所有需认证接口强制携带 JWT
axios.interceptors.request.use(
  (config) => {
    const requestUrl = config.url || '';
    if (!needsAuth(requestUrl)) {
      return config;
    }

    const token = localStorage.getItem('token');
    if (!token) {
      return Promise.reject({
        response: {
          status: 401,
          data: { detail: '未登录或登录已过期，请重新登录' },
        },
        config,
      });
    }

    setAuthHeader(config, token);
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.log('Error response:', error.response.data);
      if (error.response.status === 401 && needsAuth(error.config?.url || '')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user_info');
        const onLoginPage = window.location.pathname === '/login';
        if (!onLoginPage) {
          const redirect = encodeURIComponent(window.location.pathname + window.location.search);
          window.location.replace(`/login?redirect=${redirect}`);
        }
      }
    } else if (error.request) {
      console.log('Error request:', error.request);
    } else {
      console.log('Error message:', error.message);
    }
    return Promise.reject(error);
  }
);

// API函数
export const login = (data) => axios.post('/api/login/', data);
export const getUserInfo = () => axios.get('/api/userinfo/');
export const getUserDetail = () => axios.get('/api/userdetail/');
export const updateProfile = (data) => axios.post('/api/update_profile/', data);
export const changePassword = (data) => axios.post('/api/change_password/', data);
export const changeEmail = (data) => axios.post('/api/change_email/', data);

// 管理员API
export const adminGetUserDetail = (userId) => axios.get(`/api/admin/user/${userId}/`);
export const adminUpdateUser = (data) => axios.post('/api/admin/update_user/', data);

export default axios; 